import { render } from "./RetourCommands.vue?vue&type=template&id=702f2879"
import script from "./RetourCommands.vue?vue&type=script&setup=true&lang=js"
export * from "./RetourCommands.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Pages/Retours/Table/RetourCommands.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "702f2879"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('702f2879', __exports__)) {
    api.reload('702f2879', __exports__)
  }
  
  module.hot.accept("./RetourCommands.vue?vue&type=template&id=702f2879", () => {
    api.rerender('702f2879', render)
  })

}


export default __exports__